<form [formGroup]="pricingForm" (submit)="savePrice()">
<div formArrayName="pricing" class="grid grid-cols-3 gap-5">

    
    <div *ngFor="let group of pricingFormArray.controls; let i = index" [formGroupName]="i" class=" border bg-white rounded-lg" >
        <div class="py-3 px-5 border-b flex items-center justify-between">
            <h2 class="text-lg font-semibold">{{ group.get('price_type')?.value === 'internal' ? 'Institute Student' : 'External Student' }}</h2>
            <div class="flex items-center gap-2">
                <!-- <button class="btn btn-sm btn-circle"><i class="ri-pencil-line "></i></button> -->
            </div>
            
        </div>
        <div class="p-5 relative">

            <ul class="flex flex-col gap-3">
                <li class="grid grid-cols-2 gap-3 items-center">
                    <span class="uppercase text-sm font-semibold text-zinc-500">Gross Total</span>
                    <div>
                        <label class="input input-md input-bordered flex items-center gap-2"
                          [ngClass]="{'border-red-500': (group.get('gross_total')?.touched || isSubmitted) && group.get('gross_total')?.invalid}">
                            ₹
                            <input type="text" inputmode="numeric" maxlength="7" pattern="\d*" formControlName="gross_total" class="w-full" placeholder="" (input)="onGrossTotalInput($event, i)" />
                        </label>
                        <p *ngIf="(group.get('gross_total')?.touched || isSubmitted) && group.get('gross_total')?.hasError('required')" class="text-xs text-red-500 mt-1">Gross total is required.</p>
                        <p *ngIf="(group.get('gross_total')?.touched || isSubmitted) && group.get('gross_total')?.hasError('pattern')" class="text-xs text-red-500 mt-1">Gross total must be an integer with up to 7 digits and no letters or special characters.</p>
                        <p *ngIf="(group.get('gross_total')?.touched || isSubmitted) && group.get('gross_total')?.hasError('min')" class="text-xs text-red-500 mt-1">Gross total must be at least 1.</p>
                        <p *ngIf="(group.get('gross_total')?.touched || isSubmitted) && group.get('gross_total')?.hasError('max')" class="text-xs text-red-500 mt-1">Gross total cannot exceed 9,999,999.</p>
                    </div>
                </li>
                <li class="grid grid-cols-2 gap-3 items-center ">
                    <span class="uppercase text-sm font-semibold text-zinc-500">Discount</span>
                    <div class="flex items-center justify-end gap-2">
                        <div>
                            <input class="hidden custom-toggle" type="radio" formControlName="discount_type" value="$" id="{{ group.get('price_type')?.value }}_net" />
                            <label for="{{ group.get('price_type')?.value }}_net" class="w-full">Net</label>
                        </div>
                        <div>
                            <input class="hidden custom-toggle" type="radio" formControlName="discount_type" value="%" id="{{ group.get('price_type')?.value }}_percentage"/>
                            <label for="{{ group.get('price_type')?.value }}_percentage" class="w-full">Percentage</label>
                        </div>
                    </div>
                    <p *ngIf="(group.get('discount_type')?.touched || isSubmitted) && group.get('discount_type')?.hasError('required')" class="text-xs text-red-500 mt-1 col-span-2">Please select Net or Percentage.</p>
                </li>
                <li class="grid grid-cols-2 gap-3 items-center ">
                    <span class="uppercase text-sm font-semibold text-zinc-500">Discount</span>
                    <div>
                        <label class="input input-md input-bordered flex items-center gap-2"
                          [ngClass]="{'border-red-500': (group.get('discount')?.touched || isSubmitted) && group.get('discount')?.invalid}">
                            {{ group.get('discount_type')?.value === '$' ? '₹' : '%' }}
                            <input type="text" class="w-full" formControlName="discount" placeholder="" />
                        </label>
                        <p *ngIf="(group.get('discount')?.touched || isSubmitted) && group.get('discount')?.hasError('required')" class="text-xs text-red-500 mt-1">Discount is required.</p>
                        <p *ngIf="(group.get('discount')?.touched || isSubmitted) && group.get('discount')?.hasError('pattern')" class="text-xs text-red-500 mt-1">Discount must be an integer with no decimals or negative sign.</p>
                        <p *ngIf="group.errors?.['discountPercentageRange'] && (group.get('discount')?.touched || isSubmitted)" class="text-xs text-red-500 mt-1">Percentage must be between 0 and 100.</p>
                        <p *ngIf="group.errors?.['discountNegative'] && (group.get('discount')?.touched || isSubmitted)" class="text-xs text-red-500 mt-1">Net discount cannot be negative.</p>
                        <p *ngIf="group.errors?.['discountExceedsGross'] && (group.get('discount')?.touched || isSubmitted)" class="text-xs text-red-500 mt-1">Net discount cannot exceed gross total.</p>
                    </div>
                </li>

            </ul>
            <hr class="my-3">

            <div class="grid grid-cols-2 text-sm gap-3 font-semibold">
                <span class="uppercase   text-zinc-500">calculation</span>
                <ul class="text-end flex flex-col gap-2">
                    <li>₹{{ group.get('gross_total')?.value ?? 0 }}</li>
                    <li>{{ group.get('discount_type')?.value === '$' ? '₹' : '%' }}{{ group.get('discount')?.value ?? 0}} </li>
                    <li>- ₹ {{ group.get('total_off')?.value ?? 0 }}</li>
                </ul>
            </div>
            <hr class="my-3">
            <div class="flex items-end justify-between ">
                <span class="uppercase text-sm font-semibold text-zinc-500">Price</span>
                <p class="text-3xl font-bold">₹{{ group.get('final_price')?.value ?? 0 }}</p>
            </div>
            <!-- <hr class="my-3">
            <div class="flex justify-end mt-5 gap-3">
                <button class="btn btn-sm btn-primary">Save</button>
                <button class="btn btn-sm">Discard Changes</button>
            </div> -->
            <!-- <span class="absolute top-0 right-0 w-full h-full bg-black/5 z-10"></span> -->
        </div>
    </div>

</div>

    <hr class="my-3"> 

    <div>
        <div class="text-sm text-red-600 mb-2" *ngIf="pricingForm.get('pricing')?.touched && pricingForm.get('pricing')?.errors?.['priceRequired']">
            Please enter a price for either Institute or External students.
        </div>
        <button class="btn btn-sm btn-primary">Save</button>
    </div>

</form>



<form hidden [formGroup]="pricingForm" (submit)="savePrice()">
    <div formArrayName="pricing" class="grid grid-cols-3 gap-5">

        <div *ngFor="let group of pricingFormArray.controls; let i = index" [formGroupName]="i"
            class="border bg-white rounded-lg">

            <div class="py-3 px-5 border-b flex items-center justify-between">
                <h2 class="text-lg font-semibold">
                    {{ group.get('price_type')?.value === 'internal' ? 'Institute Student' : 'External Student' }}
                </h2>
                <!-- <div class="flex items-center gap-2">
          <button class="btn btn-sm btn-primary" type="submit">Save</button>
          <button class="btn btn-sm btn-circle" type="button"><i class="ri-close-line"></i></button>
        </div> -->
            </div>

            <div class="p-5">
                <ul class="flex flex-col gap-3">

                    <li class="grid grid-cols-2 gap-3 items-center">
                        <span class="uppercase text-sm font-semibold text-zinc-500">Gross Total</span>
                        <label class="input input-md input-bordered flex items-center gap-2">
                            ₹
                            <input type="text" class="w-full" formControlName="gross_total" />
                        </label>
                    </li>
                    <li class="grid grid-cols-2 gap-3 items-center">
                        <span class="uppercase text-sm font-semibold text-zinc-500">Discount Type</span>
                        <div class="flex items-center gap-2">
                            <div>
                                <input type="radio" class="custom-toggle" id="{{ group.get('price_type')?.value }}_net"
                                    
                                    formControlName="discount_type" value="$" />
                                <label for="{{ group.get('price_type')?.value }}_net">Net</label>
                            </div>
                            <div>
                                <input type="radio" class="custom-toggle"
                                    id="{{ group.get('price_type')?.value }}_percentage"
                                    
                                    formControlName="discount_type" value="%" />
                                <label for="{{ group.get('price_type')?.value }}_percentage">Percentage</label>
                            </div>
                        </div>
                    </li>


                    <li class="grid grid-cols-2 gap-3 items-center">
                        <span class="uppercase text-sm font-semibold text-zinc-500">Discount</span>
                        <label class="input input-md input-bordered flex items-center gap-2">
                            %
                            <input type="text" class="w-full" formControlName="discount" />
                        </label>
                    </li>

                    <li class="grid grid-cols-2 gap-3 items-center">
                        <span class="uppercase text-sm font-semibold text-zinc-500">Final Price</span>
                        <label class="input input-md input-bordered flex items-center gap-2">
                            ₹
                            <input type="text" class="w-full" formControlName="final_price" />
                        </label>
                    </li>

                </ul>
            </div>

        </div>

    </div>

    <button class="btn btn-sm btn-primary" type="submit">Save</button>
</form>
